(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-banner-hover-element"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('.banner-hover-section');
  if (!sections.length) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  sections.forEach((section) => {
    const imgEl = section.querySelector('.img-element');
    const textEl = section.querySelector('.text-heading');
    if (!imgEl && !textEl) return;

    let rafId = null;
    let lastEvent = null;

    function applyParallax(e) {
      const rect = section.getBoundingClientRect();

      const x = e.clientX - (rect.left + rect.width / 2);
      const y = e.clientY - (rect.top + rect.height / 2);

      const maxMove = 18;

      const nx = x / (rect.width / 2);
      const ny = y / (rect.height / 2);

      const cx = clamp(nx, -1, 1);
      const cy = clamp(ny, -1, 1);

      const moveX = cx * maxMove;
      const moveY = cy * maxMove;

      if (imgEl) imgEl.style.transform = `translate3d(${moveX}px, ${moveY}px, 0)`;
      if (textEl) textEl.style.transform = `translate3d(${moveX * 0.8}px, ${moveY * 0.8}px, 0)`;
    }

    section.addEventListener('mousemove', (e) => {
      lastEvent = e;
      section.classList.remove('is-leaving');

      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        applyParallax(lastEvent);
        rafId = null;
      });
    });

    section.addEventListener('mouseleave', () => {
      section.classList.add('is-leaving');

      if (imgEl) imgEl.style.transform = 'translate3d(0,0,0)';
      if (textEl) textEl.style.transform = 'translate3d(0,0,0)';

      // remove easing class after reset
      window.setTimeout(() => section.classList.remove('is-leaving'), 300);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-banner-slider"] && !Shopify.designMode) return;
  try {
    
  // Header scroll state (throttled)
  (function () {
    let last = 0;
    window.addEventListener('scroll', function () {
      const now = Date.now();
      if (now - last < 100) return;
      last = now;

      const header = document.querySelector('.header');
      if (!header) return;

      if (window.scrollY >= 100) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    }, { passive: true });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.index-product-tabs');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const swipers = new Map();
    const updateArrowPosition = (panel) => {
      const image = panel.querySelector('.product-image');
      if (!image || panel.hidden) return;
      const panelRect = panel.getBoundingClientRect();
      const imageRect = image.getBoundingClientRect();
      const imageCenter = imageRect.top - panelRect.top + imageRect.height / 2;
      panel.querySelectorAll('.index-product-tabs__arrow').forEach(arrow => {
        arrow.style.top = `${imageCenter}px`;
      });
    };
    const updateDots = (panel, swiper) => {
      const dots = panel.querySelectorAll('.index-product-tabs__dot');
      const productCount = Number(panel.dataset.productCount);
      if (!productCount) return;
      const activeIndex = Math.floor((swiper.realIndex % productCount) / 2);
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };
    const visibleCount = () => window.innerWidth >= 1200 ? 4 : window.innerWidth >= 700 ? 3 : 2;
    const initPanel = panel => {
      if (swipers.has(panel)) return swipers.get(panel).swiper;
      if (!window.Swiper) {
        window.addEventListener('load', () => initPanel(panel), { once: true });
        return;
      }
      const track = panel.querySelector('.index-product-tabs__track');
      const originals = [...track.querySelectorAll('.index-product-tabs__slide')];
      const productCount = originals.length;
      panel.dataset.productCount = productCount;
      const group = visibleCount();
      const shouldLoop = productCount > group;

      // Swiper needs at least two complete groups. Repeat only the cards needed
      // for this breakpoint so the last group flows into the first without gaps.
      if (shouldLoop) {
        const total = Math.max(group * 2, Math.ceil(productCount / group) * group);
        for (let index = productCount; index < total; index++) {
          const copy = originals[index % productCount].cloneNode(true);
          copy.dataset.carouselCopy = 'true';
          const ids = new Map();
          copy.querySelectorAll('[id]').forEach(element => {
            const uniqueId = `${element.id}-carousel-${panel.dataset.panelIndex}-${index}`;
            ids.set(element.id, uniqueId);
            element.id = uniqueId;
          });
          copy.querySelectorAll('[for], [form], [aria-labelledby], [aria-describedby]').forEach(element => {
            for (const attribute of ['for', 'form', 'aria-labelledby', 'aria-describedby']) {
              const value = element.getAttribute(attribute);
              if (value) element.setAttribute(attribute, value.split(' ').map(id => ids.get(id) || id).join(' '));
            }
          });
          copy.querySelectorAll('img').forEach(image => {
            image.loading = 'lazy';
            image.fetchPriority = 'auto';
          });
          track.append(copy);
        }
      }
      const swiper = new Swiper(panel.querySelector('[data-viewport]'), {
        slidesPerView: group,
        slidesPerGroup: group,
        spaceBetween: 20,
        loop: shouldLoop,
        watchOverflow: true,
        on: {
          init() { updateDots(panel, this); updateArrowPosition(panel); },
          slideChange() { updateDots(panel, this); },
          resize() { updateArrowPosition(panel); }
        }
      });
      panel.querySelectorAll('.index-product-tabs__arrow').forEach(button => { button.disabled = !shouldLoop; });
      swipers.set(panel, { swiper, group });
      return swiper;
    };

    root.addEventListener('click', event => {
      const control = event.target.closest('.index-product-tabs__arrow, .index-product-tabs__dot');
      if (!control) return;
      const panel = control.closest('.index-product-tabs__panel');
      const swiper = swipers.get(panel)?.swiper;
      if (!swiper) return;
      if (control.classList.contains('index-product-tabs__arrow')) {
        if (Number(control.dataset.direction) > 0) swiper.slideNext();
        else swiper.slidePrev();
      } else {
        const target = Math.min(Number(control.dataset.dotIndex) * 2, Number(panel.dataset.productCount) - 1);
        swiper.slideToLoop(target);
      }
    });

    const tabsNav = root.querySelector('.index-product-tabs__tabs');
    const tabs = root.querySelectorAll('.index-product-tabs__tab');
    const scrollTabIntoView = (tab, index) => {
      if (window.innerWidth >= 700 || !tabsNav || tabsNav.scrollWidth <= tabsNav.clientWidth + 1) return;
      const gap = parseFloat(getComputedStyle(tabsNav).gap) || 0;
      const step = tabs[0].getBoundingClientRect().width + gap;
      const target = index === 0
        ? Math.max(0, tabsNav.scrollLeft - step)
        : Math.max(0, tab.offsetLeft - (tabsNav.clientWidth - tab.offsetWidth) / 2);
      tabsNav.scrollTo({ left: target, behavior: 'smooth' });
    };

    tabs.forEach(tab => tab.addEventListener('click', () => {
      const index = tab.dataset.tabIndex;
      scrollTabIntoView(tab, Number(index));
      root.querySelectorAll('.index-product-tabs__tab').forEach(item => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      root.querySelectorAll('.index-product-tabs__panel').forEach(panel => {
        const active = panel.dataset.panelIndex === index;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) initPanel(panel);
      });
    }));

    initPanel(root.querySelector('.index-product-tabs__panel.is-active'));

    window.addEventListener('resize', () => {
      [...swipers].forEach(([panel, { swiper, group }]) => {
        if (group === visibleCount()) return;
        swiper.destroy(true, true);
        panel.querySelectorAll('[data-carousel-copy]').forEach(copy => copy.remove());
        swipers.delete(panel);
        if (!panel.hidden) initPanel(panel);
      });
    }, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        const activePanel = root.querySelector('.index-product-tabs__panel.is-active');
        if (activePanel) updateArrowPosition(activePanel);
      });
      root.querySelectorAll('.index-product-tabs__panel').forEach(panel => {
        const image = panel.querySelector('.product-image');
        if (image) resizeObserver.observe(image);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-tab-product-list"] && !Shopify.designMode) return;
  try {
    
    const tabsContainer = document.getElementById('tabs-container');
    const tabs = tabsContainer.querySelectorAll('.tab');
    const radios = tabsContainer.querySelectorAll('input[type=radio]');
    const glider = tabsContainer.querySelector('.glider');
    const tabItems = document.querySelectorAll('.tab-container-item');

    function moveGlider() {
        const selectedIndex = Array.from(radios).findIndex(r => r.checked);
        const activeTab = tabs[selectedIndex];
        const width = activeTab.offsetWidth;
        const x = activeTab.offsetLeft;

        glider.style.setProperty('--glider-width', width + 'px');
        glider.style.setProperty('--glider-x', x + 'px');
    }

    function updateArrowPosition(tabItem) {
        if (!tabItem || getComputedStyle(tabItem).display === 'none') return;

        const productImage = tabItem.querySelector('.product-image');
        const floatNav = tabItem.querySelector('.float-nav');
        const arrow = floatNav?.querySelector('.owl-prev, .owl-next');
        if (!productImage || !floatNav || !arrow || getComputedStyle(arrow).display === 'none') return;

        // Reset first so every recalculation is based on the global float-nav
        // position rather than accumulating the previous correction.
        floatNav.style.setProperty('--product-image-nav-offset', '0px');

        const imageRect = productImage.getBoundingClientRect();
        const arrowRect = arrow.getBoundingClientRect();
        const imageCenter = imageRect.top + (imageRect.height / 2);
        const arrowCenter = arrowRect.top + (arrowRect.height / 2);
        const verticalOffset = imageCenter - arrowCenter;

        floatNav.style.setProperty('--product-image-nav-offset', `${verticalOffset}px`);
    }

    function updateArrowPositions() {
        tabItems.forEach(updateArrowPosition);
    }

    function switchTabs() {
        const selectedRadio = this;
        const tabId = selectedRadio.dataset.tabId;

        // First hide all tabs completely
        tabItems.forEach(item => {
            item.style.display = "none";
            item.style.opacity = 0;
            item.style.transition = "none"; // reset to avoid unwanted animation
        });

        // Then show the selected tab and fade it in
        const selectedItem = Array.from(tabItems).find(
            item => item.dataset.tabId === tabId
        );

        if (selectedItem) {
            selectedItem.style.display = "block";
            selectedItem.style.transition = "opacity 0.3s ease 0.1s";
            requestAnimationFrame(() => {
                updateArrowPosition(selectedItem);
                selectedItem.style.opacity = 1;
            });
        }

        moveGlider();
    }

    moveGlider();
    updateArrowPositions();


    radios.forEach(radio => {
        radio.addEventListener('change', switchTabs);
    });

    // Initialize on load
    window.addEventListener('load', () => {
        moveGlider();
        updateArrowPositions();
    });
    window.addEventListener('resize', () => {
        moveGlider();
        updateArrowPositions();
    });

    if ('ResizeObserver' in window) {
        const arrowPositionObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                updateArrowPosition(entry.target.closest('.tab-container-item'));
            });
        });

        tabItems.forEach(item => {
            const productImage = item.querySelector('.product-image');
            if (productImage) arrowPositionObserver.observe(productImage);
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendation"] && !Shopify.designMode) return;
  try {
    
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection) {
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
        .then(response => response.text())
        .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        // Initialize Swiper for recommendation slider
        $('.product-recommendations .recommendation-slider').each(function () {
            const sliderEl = this;
            const scopeEl = sliderEl.closest('.product-recommendations');
            const floatNav = scopeEl.querySelector('.float-nav');
            // Read the count before Swiper touches the DOM so loop mode can't
            // inflate it.
            const productCount = sliderEl.querySelectorAll('.swiper-slide').length;

            const swiper = new Swiper(sliderEl, {
            slidesPerView: 4,
            spaceBetween: 15,
            allowTouchMove: true,
            loop: true,
            navigation: {
                nextEl: floatNav.querySelector('.owl-next'),
                prevEl: floatNav.querySelector('.owl-prev'),
            },
            breakpoints: {
                1524: {
                slidesPerView: 4,
                },
                1024: {
                slidesPerView: 4,
                },
                768: {
                slidesPerView: 2,
                },
                0: {
                slidesPerView: 2,
                },
            },
            });

            // The arrows only earn their space when something is off-screen to
            // reach, and they have to sit on the product image rather than the
            // middle of the whole card.
            const syncNav = () => window.requestAnimationFrame(() => {
                const perView = Number(swiper.params.slidesPerView) || 1;
                const hideNav = productCount <= perView;
                floatNav.classList.toggle('is-nav-hidden', hideNav);
                if (hideNav) return;

                // Reset before measuring so each pass reads the uncorrected
                // position instead of stacking on the previous offset.
                floatNav.style.setProperty('--product-image-nav-offset', '0px');

                const productImage = sliderEl.querySelector('.product-image');
                const arrow = floatNav.querySelector('.owl-prev, .owl-next');
                if (!productImage || !arrow) return;

                const imageRect = productImage.getBoundingClientRect();
                const arrowRect = arrow.getBoundingClientRect();
                floatNav.style.setProperty(
                    '--product-image-nav-offset',
                    `${(imageRect.top + imageRect.height / 2) - (arrowRect.top + arrowRect.height / 2)}px`
                );
            });

            syncNav();
            swiper.on('breakpoint resize', syncNav);
            window.addEventListener('load', syncNav);
        });
        })
        .catch(e => {
        console.error(e);
        });
    }


  } catch(e) { console.error(e); }
})();
})();
